import BaseUIMediator from "../../LTGame/UIExt/FGui/BaseUIMediator";
import UI_splash from "../../ui/Load/UI_splash";
export default class UI_LoadMediator extends BaseUIMediator {
    constructor() {
        super(...arguments);
        this._sortOrder = Number.MAX_SAFE_INTEGER;
    }
    static get instance() {
        if (!UI_LoadMediator._instance) {
            UI_LoadMediator._instance = new UI_LoadMediator();
            UI_LoadMediator._instance._classDefine = UI_splash;
        }
        return UI_LoadMediator._instance;
    }
    _OnShow() {
        super._OnShow();
        this._ui.m_progress.max = 100;
        this._ui.m_progress.value = this._openParam;
        this._enable = false;
        this.loadProgressHadler = Laya.Handler.create(this, this.onLayaLoadProgress, null, false);
    }
    _OnHide() {
        super._OnHide();
    }
    EnableProgress() {
        this._enable = true;
    }
    onLayaLoadProgress(p) {
        if (this.isShow)
            this._ui.m_progress.value = p * 100;
    }
    _onProgress(p) {
        if (this._enable) {
            this._ui.m_progress.value = p;
        }
    }
}
